import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { addSearchParams, stripSearchString } from 'shared/utils';
import { useRequest } from 'shared/hooks';
import StickyHeadTable from './StickyHeadTable';

/**
 * @param {Object} props
 * @param {string} [props.baseSearch=''] - Pass this search string to the searching service
 * @param {string} [props.className='']
 * @param {Array<Object>} props.columns
 * @param {Function} props.searchRequest - Examples in client/src/services directory
 * @param {Array<string>} [props.ignoredKeys=[]] - Keys that aren't passed to backend
 * @param {string} [props.noRowsText='Results not found']
 * @param {string} props.rowId
 * @param {number} [props.updateCount=0] - Changing this forces table to reload
 */
// Requests all data from search service.
// It does not paginate or apply server side filters.
export default function SimpleDataTable(props) {
  const [rows, setRows] = useState(undefined);
  const { search } = useLocation();
  const { request } = useRequest();

  const {
    baseSearch = '',
    className = '',
    columns,
    searchRequest,
    ignoredKeys = [],
    noRowsText = 'Results not found',
    rowId,
    updateCount = 0,
  } = props;

  const backendSearchString = stripSearchString(
    addSearchParams(search, baseSearch),
    ignoredKeys,
  ).toString();

  useEffect(() => {
    async function loadData() {
      const result = await request(searchRequest(`?${backendSearchString}`, 'application/json'));
      if (result === undefined) {
        return;
      }
      if (result === null) {
        setRows([]);
      }
      setRows(result.rows);
    }

    loadData();
  }, [request, backendSearchString, searchRequest, updateCount]);

  if (rows === undefined) {
    return null;
  }

  return (
    <StickyHeadTable
      search={search}
      className={className}
      columns={columns}
      noRowsText={noRowsText}
      rowId={rowId}
      rows={rows}
      striped
    />
  );
}
